import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class AuthBaseService {
    constructor(
        public http: HttpClient,
        public authService: AuthService
    ) {}

    PAGE_SIZE = 25;

    apiUrl(endpoint: string): string {
        const host: string = (window as any)['__env'].apiEndpoint;
        const url = `${host}/${endpoint}`;
        return url;
    }

    getOptions() {
        return {
            headers: new HttpHeaders({
                Authorization: 'Bearer ' + this.token()
            }),
            withCredentials: true
        };
    }

    checkAndRenewToken() {
        this.authService.checkAndRenewToken();
    }

    token() {
        return this.authService.getToken();
    }
}
